import React from 'react'
import styles from './styles.scss'

const FieldError = ({ error }) => {
  return <span className={styles.validationError}>{error}</span>
}

export default FieldError
